import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import selectors from '@/redux/selectors/selectors';
import { useArgSelector } from '@/redux/curriedSelectors/curriedSelectors';
import { featureIds } from '@shared/schema/featureIds.js';
import formatNumber from '@/lib/formatNumber';
import getPercentage from '@/components/platform/platformCurrentPlan/getPercentage';

const thirtyDaysAgo = new Date();
thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);

const createMockData = () => {
  const today = new Date();
  const data = [];
  for (let i = 44; i >= 0; i--) {
    const date = new Date(today);
    date.setDate(date.getDate() - i);
    data.push({
      date: date.toISOString().split('T')[0],
      tasks: 0,
      color: '#c7c8c9'
    });
  }
  return data;
};

const useBillingCycle = () => {
  const usage = useSelector((state) => state?.settings?.usage);
  const feature = useArgSelector(selectors.subscriptionFeature, featureIds.tasks);
  const operationLimit = useSelector((state) => state?.settings?.companyLimits?.operationLimit);

  const processedData = useMemo(() => {
    return usage
      ? usage.map((item) => ({
          date: item.day,
          tasks: +item.tasks,
          color: new Date(item.day) >= thirtyDaysAgo ? '#82b8ed' : '#c7c8c9'
        }))
      : createMockData();
  }, [usage]);

  const tasksUsed = useMemo(() => processedData.slice(-30).reduce((acc, item) => acc + item.tasks, 0), [processedData]);

  const freePlanLimit = 100;
  const isFreePlan = Object.keys(feature || {}).length === 0 && !operationLimit;
  const limit = isFreePlan ? freePlanLimit : operationLimit || +feature?.option;
  const hasReachedLimit = limit - tasksUsed <= 0;
  const formattedTasksUsed = useMemo(() => formatNumber(tasksUsed), [tasksUsed]);
  const tasksRemaining = useMemo(() => (hasReachedLimit ? 'None' : formatNumber(limit - tasksUsed)), [hasReachedLimit, limit, tasksUsed]);
  const percentage = useMemo(() => getPercentage(tasksUsed, limit), [tasksUsed, limit]);

  return {
    processedData,
    tasksUsed,
    hasReachedLimit,
    limit,
    formattedTasksUsed,
    tasksRemaining,
    percentage,
    isFreePlan,
    freePlanLimit
  };
};

export default useBillingCycle;
